export interface INotificationType {
    id: number;
    name: string;
}